import React from 'react';
import { motion } from 'framer-motion';
import styled from '@emotion/styled';

const Card = styled(motion.a)`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  margin-bottom: 16px;
  text-decoration: none;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 16px;
  background-color: ${props => props.bgColor || '#555'};
  color: #ffffff;
  font-size: 20px;
`;

const TextContent = styled.div`
  flex: 1;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
`;

const Username = styled.p`
  margin: 0;
  font-size: 14px;
  opacity: 0.8;
`;

const ProfileCard = ({ title, username, icon, url, color, index }) => {
  return (
    <Card 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.3,
        delay: index * 0.1 + 0.3 // Staggered animation
      }}
    >
      <IconWrapper bgColor={color}>
        {icon}
      </IconWrapper>
      <TextContent>
        <Title>{title}</Title>
        <Username>{username}</Username>
      </TextContent>
    </Card>
  );
};

export default ProfileCard; 